module.exports = __webpack_public_path__ + "img/AT0000002579587.1b3f9fee.png";